import {Component, Inject, OnInit} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { BusinessFeesService } from '../services/business-fees.service';
import { EditFeeComponent } from '../edit-fee/edit-fee.component';


@Component({
  selector: 'app-delete-fee',
  templateUrl: './delete-fee.component.html',
  styleUrls: ['./delete-fee.component.scss']
})
export class DeleteFeeComponent implements OnInit {
  serviceId: number;
  businessID: number;
  isLoading = false;

  constructor(private _matDialogRef: MatDialogRef<EditFeeComponent>,
              @Inject(MAT_DIALOG_DATA) data,
              private _feeService: BusinessFeesService) {
    this.serviceId = data.serviceId;
    this.businessID = data.businessID;
  }

  ngOnInit() {
    this._matDialogRef.backdropClick().subscribe(() => {
      this.close({cancelBtnClicked: true});
    });
  }

  close(data: any) {
    this._matDialogRef.close(data);
  }

  async delete() {
    try {
      this.isLoading = true;
      await this._feeService.deleteBusinessService(this.businessID, this.serviceId);
      this.isLoading = false;
      this.close({success: true});
    } catch (e) {
      this.close({success: false});
    }
  }

  cancel () {
    this.close({cancelBtnClicked: true});
  }
}
